module.exports = __webpack_public_path__ + "static/media/shoes2x.486c6fb4.png";